export interface IActivityLogFilters {
    entity_type: string | null;
    event_code: string | null;
    source: string | null;
    operation_type: string | null;
}

export interface IActivityLogFilterOptions {
    entity_types: string[];
    event_codes: string[];
    sources: string[];
    operation_types: string[];
}

export interface IActivityLogRange {
    from: string;
    to: string;
}

export type ActivityLogFilterKey = keyof IActivityLogFilters;

export const EMPTY_ACTIVITY_LOG_FILTERS: IActivityLogFilters = {
    entity_type: null,
    event_code: null,
    source: null,
    operation_type: null,
};
